export default "__VITE_ASSET__B7m1$4FU__"